var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMediaIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-media-icons") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Graphics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Media-library-V2",
    transform: "translate(-20.000000, -251.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-media-icons",
    transform: "translate(20.000000, 251.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#FFFFFF",
    strokeWidth: 0.72,
    strokeLinecap: "round",
    x: 0.36,
    y: 0.36,
    width: 17.28,
    height: 17.28
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.36,
    y1: 9,
    x2: 17.64,
    y2: 9,
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.72,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 17.64,
    x2: 9,
    y2: 0.36,
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.72,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.72,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "9 7.3638 6.64272 5.13828 5.07096 5.9238 3.10932 3.56724 0.36 5.9238"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    cx: 6.84,
    cy: 2.88,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    cx: 11.52,
    cy: 11.16,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.47432,13.77468 C7.659,13.05864 6.73056,12.48084 6.51996,12.36024 C6.49368,12.34512 6.4782,12.3372 6.4782,12.3372 C6.4782,12.3372 6.76908,11.0412 6.0642,10.63764 C5.35968,10.23408 4.38876,11.14092 4.38876,11.14092 C4.38876,11.14092 4.33332,11.10132 4.23936,11.04768 C3.91896,10.86408 3.1536,10.51488 2.64564,11.00952 C1.98792,11.64924 2.60604,12.75804 2.60604,12.75804 C2.60604,12.75804 1.63908,13.55868 1.94256,14.37624 C2.016,14.57352 2.14992,14.70888 2.3112,14.8014 C2.81808,15.09156 3.59352,14.95404 3.59352,14.95404 C3.59352,14.95404 3.92904,15.66468 4.44492,15.95988 C4.59216,16.04412 4.75416,16.09452 4.92732,16.08516 C5.70636,16.04196 5.9868,14.69376 5.9868,14.69376 C5.9868,14.69376 7.26588,14.58072 7.47432,13.77468 Z",
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.72,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3998,4.6836 L16.39188,4.68108 C16.39332,4.68036 16.3998,4.6782 16.3998,4.6782 C16.3998,4.6782 15.25896,4.23648 15.1668,3.9564 C15.01776,3.50604 15.49764,2.50164 15.49764,2.50164 C15.49764,2.50164 14.463,3.05748 14.1246,2.87712 C13.78656,2.69712 13.32,1.6002 13.32,1.6002 C13.32,1.6002 12.942,2.71908 12.58812,2.8692 C12.23388,3.01932 11.14344,2.50128 11.14344,2.50128 C11.14344,2.50128 11.62908,3.59208 11.51028,3.95424 C11.42496,4.21272 10.2402,4.6764 10.2402,4.6764 L10.24812,4.67892 C10.24668,4.67928 10.2402,4.6818 10.2402,4.6818 C10.2402,4.6818 11.39292,5.094 11.4732,5.4036 C11.59164,5.8626 11.14236,6.85836 11.14236,6.85836 C11.14236,6.85836 12.177,6.30252 12.5154,6.48288 C12.85272,6.66288 13.32,7.7598 13.32,7.7598 C13.32,7.7598 13.698,6.64092 14.05116,6.4908 C14.4054,6.34068 15.4962,6.85872 15.4962,6.85872 C15.4962,6.85872 15.00408,5.76576 15.12936,5.40576 C15.22656,5.12604 16.3998,4.6836 16.3998,4.6836 Z M13.32,6.09012 C12.54024,6.09012 11.90844,5.45868 11.90844,4.68 C11.90844,3.90132 12.54024,3.26988 13.32,3.26988 C14.0994,3.26988 14.73156,3.90132 14.73156,4.68 C14.73156,5.45868 14.0994,6.09012 13.32,6.09012 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.28416,13.40784 C15.14808,12.7404 14.55984,12.24 13.87404,12.24 C13.38012,12.24 12.91932,12.50244 12.65832,12.92112 C12.0384,12.85344 11.52972,13.25448 11.37708,13.81644 C10.85472,13.84812 10.44,14.28948 10.44,14.82732 C10.44,15.38568 10.88712,15.84 11.43684,15.84 L14.98176,15.84 C15.65352,15.84 16.2,15.28488 16.2,14.60232 C16.2,14.03064 15.81696,13.545 15.28416,13.40784 Z",
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.72,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.72932,13.20984 C4.72932,13.20984 5.24196,14.33484 4.7826,14.40828 C4.32288,14.48136 4.57704,13.22676 4.57704,13.22676 C4.57704,13.22676 3.59892,14.05692 3.4542,13.6476 C3.30948,13.23828 4.51476,13.08708 4.51476,13.08708 C4.51476,13.08708 3.41028,12.4452 3.76704,12.14892 C4.12416,11.85264 4.6278,12.98412 4.6278,12.98412 C4.6278,12.98412 4.89168,11.75616 5.28912,11.98368 C5.68656,12.2112 4.761,13.06044 4.761,13.06044 C4.761,13.06044 5.985,12.92004 5.9166,13.37976 C5.8482,13.83948 4.72932,13.20984 4.72932,13.20984 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMediaIcons);
export default __webpack_public_path__ + "static/media/icon-media-icons.05f0b0bfdcb5f52ad4f139ba73cf059c.svg";
export { ForwardRef as ReactComponent };